export default __webpack_public_path__ + "static/media/hotspot-inner-white.cafb9cd0.svg";